<template>
  <v-card class="card" color="primary">
    <template v-if="personal">
      <v-card-title>
        <div class="text-h5 font-weight-bold">Referencias</div>
        <v-spacer></v-spacer>
        <reporte-referencias-component :referencias="referencias"></reporte-referencias-component>
        <v-tabs v-model="selectedTab" color="secondary" fixed-tabs>
          <v-tab class="font-weight-bold">Vecinal</v-tab>
          <v-tab class="font-weight-bold">Personal</v-tab>
          <v-tab class="font-weight-bold">Laboral</v-tab>
        </v-tabs>
      </v-card-title>
      <v-card-text>
        <v-tabs-items v-model="selectedTab" class="transparent">
          <v-tab-item key="1">
            <v-container>
              <v-row v-if="loadingReferencias">
                <v-col cols="12" align="center">
                  <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
                  <div class="text-h6 mt-2">Cargando referencias...</div>
                </v-col>
              </v-row>
              <v-row v-else-if="referencias.length > 0">
                <v-col cols="4" v-for="referencia in referencias" :key="referencia.id">
                  <v-card color="primary" class="card">
                    <v-card-title class="justify-center">
                      <div class="text-subtitle-1 font-weight-bold">
                        {{ referencia.Nombre }}
                      </div>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="6">
                            <div class="text-subtitle-2">Tipo de referencia</div>
                          </v-col>
                          <v-col cols="6" align="right">
                            <div class="text-subtitle-2 font-weight-bold">
                              {{ referencia.CatTipoReferencia.title }}
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div class="text-subtitle-2">Tiempo de conocerse</div>
                          </v-col>
                          <v-col cols="6" align="right">
                            <div class="text-subtitle-2 font-weight-bold">{{ referencia.tiempoConocerse }} años</div>
                          </v-col>
                          <v-col cols="6">
                            <div class="text-subtitle-2">Ocupación</div>
                          </v-col>
                          <v-col cols="6" align="right">
                            <div class="text-subtitle-2 font-weight-bold">{{ referencia.CatOcupacion.title }}</div>
                          </v-col>
                          <v-col cols="6">
                            <div class="text-subtitle-2">Teléfono</div>
                          </v-col>
                          <v-col cols="6" align="right">
                            <div class="text-subtitle-2 font-weight-bold">{{ referencia.telefono }}</div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-else>
                <v-col cols="12" align="center">
                  <v-icon color="primary darken-3" size="256">mdi-account-multiple</v-icon>
                  <div class="text-h6">Este elemento no ha registrado referencias</div>
                </v-col>
              </v-row>
              <v-row v-if="!loadingReferencias">
                <v-col cols="12" align="center">
                  <TextButton
                    v-if="perfil !== PERFILES['Administrador IPH+'] && perfil !== PERFILES['Policia']"
                    :to="{ name: getReferenciaRouteName, params: { id: personal.idPersonal } }"
                  >
                    Agregar referencia
                  </TextButton>
                  <agrega-referencia-dialog-component
                    v-else
                    :id="personal.idPersonal"
                  ></agrega-referencia-dialog-component>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <!-- TAB FAMILIARES -->
          <v-tab-item key="2">
            <v-container>
              <v-row v-if="loadingFamiliares">
                <v-col cols="12" align="center">
                  <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
                  <div class="text-h6 mt-2">Cargando familiares...</div>
                </v-col>
              </v-row>
              <v-row v-else-if="familiares.length > 0">
                <v-col cols="4" v-for="familiar in familiares" :key="familiar.id">
                  <v-card color="primary" class="card">
                    <v-card-title class="justify-center d-block" align="center">
                      <div class="text-subtitle-1 font-weight-bold">{{ getFullName(familiar) }}</div>
                      <div class="text-subtitle-2">{{ familiar.CatParentesco.title }}</div>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="6">
                            <div class="text-subtitle-2">Fecha de nacimiento</div>
                          </v-col>
                          <v-col cols="6" align="right">
                            <div class="text-subtitle-2 font-weight-bold">
                              {{ familiar.fechaNacimiento }}
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div class="text-subtitle-2">Edad</div>
                          </v-col>
                          <v-col cols="6" align="right">
                            <div class="text-subtitle-2 font-weight-bold">{{ getAge(familiar.fechaNacimiento) }}</div>
                          </v-col>
                          <v-col cols="6">
                            <div class="text-subtitle-2">Sexo</div>
                          </v-col>
                          <v-col cols="6" align="right">
                            <div class="text-subtitle-2 font-weight-bold">{{ familiar.CatSexo.title }}</div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-else>
                <v-col cols="12" align="center">
                  <v-icon color="primary darken-3" size="256">mdi-account-multiple</v-icon>
                  <div class="text-h6">Este elemento no cuenta con familiares registrados</div>
                </v-col>
              </v-row>
              <v-row v-if="!loadingFamiliares">
                <v-col cols="12" align="center">
                  <TextButton
                    v-if="perfil !== PERFILES['Administrador IPH+'] && perfil !== PERFILES['Policia']"
                    :to="{ name: getFamiliarRouteName, params: { id: personal.idPersonal } }"
                    >Agregar familiar</TextButton
                  >
                  <agrega-familiar-dialog-component v-else :id="personal.idPersonal"></agrega-familiar-dialog-component>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </template>
    <template v-else>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="12" align="center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-col>
        </v-row>
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AgregaFamiliarDialogComponent from '../../../../views/policia/AgregaFamiliarDialogComponent.vue'
import AgregaReferenciaDialogComponent from '../../../../views/policia/AgregaReferenciaDialogComponent.vue'
import ReporteReferenciasComponent from '../../ReporteReferenciasComponent.vue'
import TextButton from '../../../base/TextButton.vue'
import { PERFILES } from '@/perfiles.js'

export default {
  components: {
    ReporteReferenciasComponent,
    AgregaFamiliarDialogComponent,
    AgregaReferenciaDialogComponent,
    TextButton,
  },

  data() {
    return {
      PERFILES,
      selectedTab: 0,
      loadingReferencias: true,
      loadingFamiliares: true,
    }
  },

  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
    idPersonal() {
      return this.personal?.idPersonal
    },
    ...mapGetters({
      perfil: 'getPerfil',
    }),
    ...mapGetters('referencias', {
      referenciasVecinal: 'getReferenciaVecinal',
      referenciasLaborales: 'getReferenciasLaborales',
      referenciasPersonales: 'getReferenciasPersonales',
    }),
    ...mapGetters('familiares', {
      familiares: 'getFamiliares',
    }),
    referencias() {
      if (this.selectedTab === 0) return this.referenciasVecinal
      if (this.selectedTab === 1) return this.referenciasPersonales
      if (this.selectedTab === 2) return this.referenciasLaborales
      return []
    },

    getReferenciaRouteName() {
      if (this.$route.matched.some(({ path }) => path === '/profesionalizacion')) {
        return 'agregaReferencia'
      } else if (this.$route.matched.some(({ path }) => path === '/personal')) {
        return 'agregaReferenciaSite'
      } else if (this.$route.matched.some(({ path }) => path === '/recursos_humanos')) {
        return 'recursos_humanos.agrega_referencia_personal'
      } else if (this.$route.matched.some(({ path }) => path === '/enlace_c3')) {
        return 'enlace_c3.agrega_referencia'
      }
    },

    getFamiliarRouteName() {
      if (this.$route.matched.some(({ path }) => path === '/profesionalizacion')) {
        return 'profesionalizacion.agrega_familiar'
      } else if (this.$route.matched.some(({ path }) => path === '/personal')) {
        return 'registro_personal.agrega_familiar'
      } else if (this.$route.matched.some(({ path }) => path === '/recursos_humanos')) {
        return 'recursos_humanos.agrega_familiar'
      } else if (this.$route.matched.some(({ path }) => path === '/enlace_c3')) {
        return 'enlace_c3.agrega_familiar'
      }
    },
  },

  async mounted() {
    if (this.idPersonal) {
      this.loadingReferencias = true
      this.loadingFamiliares = true
      await this.fetchReferenciasByPersonal(this.idPersonal)
      this.loadingReferencias = false
      await this.fetchFamiliaresByPersonal(this.idPersonal)
      this.loadingFamiliares = false
    }
  },

  methods: {
    ...mapActions('referencias', ['fetchReferenciasByPersonal']),
    ...mapActions('familiares', ['fetchFamiliaresByPersonal']),
    getFullName(familiar) {
      return [familiar.nombre, familiar.primerApellido, familiar.segundoApellido].filter(Boolean).join(' ')
    },
    getAge(fechaNacimiento) {
      if (!fechaNacimiento) return ''
      const moment = require('moment')
      const birth = moment(fechaNacimiento, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601])
      if (!birth.isValid()) return ''
      return moment().diff(birth, 'years') + ' años'
    },
  },
}
</script>
